import { memo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheveronRight = props => /*#__PURE__*/_jsx("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  className: `svg-icon ${props.className || ''}`,
  children: /*#__PURE__*/_jsx("path", {
    d: "m23.999 18 2-2-16-16L6 3.999 17.998 16 6 28.001 9.999 32z"
  })
});
const Memo = /*#__PURE__*/memo(SvgCheveronRight);
export default Memo;